import React from "react";
import { format, parseISO } from "date-fns";
import { CashflowLog, CashflowSource } from "../interface";

const SOURCE_LABELS: Record<CashflowSource, string> = {
    giveaway: "Giveaway",
    adjustment: "Adjustment",
};

interface CashflowHistoryTableProps {
    logs: CashflowLog[];
}

const CashflowHistoryTable: React.FC<CashflowHistoryTableProps> = ({ logs }) => {
    return (
        <div className="relative overflow-x-auto rounded-2xl mt-4 overflow-y-auto max-h-full bg-white shadow-sm">
            <table className="w-full text-sm text-left rtl:text-right text-gray-600">
                <thead className="text-xs text-gray-400 uppercase tracking-wide">
                    <tr>
                        <th scope="col" className="px-2 sm:px-4 py-3">Date</th>
                        <th scope="col" className="px-2 sm:px-4 py-3">Source</th>
                        <th scope="col" className="px-2 sm:px-4 py-3">Description</th>
                        <th scope="col" className="px-2 sm:px-4 py-3">Amount</th>
                        <th scope="col" className="px-2 sm:px-4 py-3">Total Given</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map((log) => (
                        <tr
                            key={log.id}
                            className="border-t border-gray-100 last:border-b-0 hover:bg-p-gray/60 transition-colors"
                        >
                            <td className="px-2 sm:px-4 py-4 min-w-28">
                                {format(parseISO(log.created_at), "MMM d")}
                            </td>
                            <td className="px-2 sm:px-4 py-4 min-w-32">{SOURCE_LABELS[log.source]}</td>
                            <td className="px-2 sm:px-4 py-4 min-w-44">{log.description ?? "—"}</td>
                            <td className="px-2 sm:px-4 py-4 min-w-24 font-semibold text-gray-800">
                                ${log.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}
                            </td>
                            <td className="px-2 sm:px-4 py-4 min-w-28 font-semibold text-gray-800">
                                ${log.total_given_after.toLocaleString(undefined, { style: "currency", currency: "USD" })}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CashflowHistoryTable;
